// import { Form } from 'formik'
import { HTMLAttributes } from 'react'
import Image from 'next/image'

import Container from '@/components/base/container'
import Form from '@/components/base/form'
import Grid from '@/components/base/grid'
import Typography from '@/components/base/typography'
import Spacer from '@/components/sections/spacer'
import { useStore } from '@/contexts/store'

import { useContactFormMotion } from './motion'
import { cn } from '@/lib/utils'

export type SectionContactsProps = HTMLAttributes<HTMLDivElement>

const SectionContacts = ({ ...props }: SectionContactsProps) => {
  const { strings } = useStore()
  const { motionRef } = useContactFormMotion()
  const { text_1, text_2, image, form } = strings?.contacts || {}

  console.log('form.form.fields ---->', form?.form?.fields)

  return (
    <section
      ref={motionRef}
      className={cn(
        'relative',
        'text-text-primary-light dark:text-text-primary-light',
        'bg-white-light dark:bg-white-dark'
      )}
      {...props}
    >
      <Spacer variant="md" className="bg-transparent dark:bg-transparent" />
      <Spacer variant="2xl" className="bg-transparent dark:bg-transparent" />

      <Container>
        <Grid className="gap-y-spacing-lg">
          <div
            className={cn(
              'col-span-2 md:col-span-4 md:col-start-2 lg:col-span-5',
              'grid gap-y-spacing-sm md:gap-y-spacing-lg'
            )}
            data-motion-col
          >
            <div className="grid gap-y-spacing-sm md:flex md:space-x-gutter">
              <div className="flex">
                <Typography variant="body" data-motion-info-1>
                  {text_1}
                </Typography>
              </div>
              <div className="flex">
                <Typography variant="body" data-motion-info-2>
                  {text_2}
                </Typography>
              </div>
            </div>
            <div className="relative h-full w-full overflow-clip" data-motion-image-mask>
              <Image
                src={image?.url || ''}
                width={image?.width || 0}
                height={image?.height || 0}
                alt={image?.alt || 'Contacts Illustration'}
                className="h-auto w-full"
                data-motion-image
              />
            </div>
          </div>

          <div
            className={cn(
              'col-span-2 md:col-span-4 md:col-start-2 lg:col-span-6 lg:col-start-7',
              'grid gap-y-spacing-lg'
            )}
            data-motion-col
          >
            <div className="grid gap-y-spacing-sm">
              {form?.title ? (
                <div className="flex">
                  <Typography variant="large" component="h2" data-motion-title>
                    {`<b>${form?.title}</b>`}
                  </Typography>
                </div>
              ) : null}

              {form?.text ? (
                <div className="flex">
                  <Typography variant="body" data-motion-paragraph>
                    {form?.text}
                  </Typography>
                </div>
              ) : null}
            </div>

            {form?.form ? (
              <Form
                form_id={form.form.id}
                fields={form.form.fields}
                submit={form.form.button?.text}
              />
            ) : null}
          </div>
        </Grid>
      </Container>

      <Spacer variant="2xl" className="bg-transparent dark:bg-transparent" />
    </section>
  )
}

export default SectionContacts
